import { createContext, useContext, useEffect } from 'react';
import { Socket } from 'socket.io-client';

interface SocketContextType {
  socket?: Socket;
  isConnected?: boolean;
  error?: string | null;
}

interface SocketSubscription<T> {
  event: string;
  onMessage: (payload: T) => void;
}

export const SocketContext = createContext<SocketContextType>({});

export const useSocketSubscription = <T>(config: SocketSubscription<T>[]) => {
  const { socket } = useContext(SocketContext);

  useEffect(() => {
    if (socket) {
      config.forEach(({ event, onMessage }) => socket.on(event, onMessage));
    }
    return () => config.forEach(({ event }) => socket?.off(event));
  }, [socket, config]);
};
